export function formatTime (ms) {
  const s = Math.floor(ms / 1000)
  return `${zeroPad(Math.floor(s / 60))}:${zeroPad(s % 60)}`
}

function zeroPad (num) {
  if (num < 10) return `0${num}`
  return num
}
